// Redux.
import { connect } from 'react-redux';

// React state and router.
import { useEffect, useState } from 'react'

// Components.
import { getAnalytics, logEvent } from "firebase/analytics";
import DownloadAppStoreLink from '../components/DownloadAppStoreLink';
import { IOS_APP_STORE_LINK, LABEL_TAGLINE } from '../constants/labels';


const QRCodeScan = ({ }) => {

    const analytics = getAnalytics();
    useEffect(() => {
        logEvent(analytics, 'qr_code_scan');
        window.location.replace(IOS_APP_STORE_LINK);
    }, [analytics]);

    return (
        <div>
            <div className='center' style={{ textAlign: 'center' }}>
                <a href='/'>
                    <div>
                        <img style={{ width: '180px', marginBottom: '20px' }} src='/appname.png' />
                    </div>
                    <div className='tagline' style={{ margin: '0px auto', maxWidth: '280px', fontWeight: '500' }}>
                        <div>
                            {LABEL_TAGLINE}
                        </div>
                    </div>
                </a>
                <div style={{ textAlign: 'center', padding: '30px 0px'}}>
                    <img src='/qrcode.png' style={{ width: '224px' }} />
                </div>
                <DownloadAppStoreLink />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({

})

const mapActionsToProps = {

}

export default connect(mapStateToProps, mapActionsToProps)(QRCodeScan);